import { render, staticRenderFns } from "./DuplicateWorkflowDialog.vue?vue&type=template&id=82ce2784&"
import script from "./DuplicateWorkflowDialog.vue?vue&type=script&lang=ts&"
export * from "./DuplicateWorkflowDialog.vue?vue&type=script&lang=ts&"
import style0 from "./DuplicateWorkflowDialog.vue?vue&type=style&index=0&id=82ce2784&prod&lang=scss&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports